import styled from "styled-components";

const RedeemLink = styled.a`
  color: #222;
  transition: color 0.12s ease-out 0s;
  text-decoration: none;

  &:hover {
    color: #222;
  }
`;
export default RedeemLink;
